import { useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Plus } from "lucide-react";
import { HoldRow } from "@/pages/admin/Stock";
import { REQ_TYPES, REQ_STATUS, NewRequestModal } from "@/pages/admin/Requests";

export function WatchClientsBadge({ w, open, onToggle }) {
  const n = w.holds.length, i = (w.interests || []).length;
  if (!n && !i) return <button type="button" onClick={onToggle} className="text-xs text-[#A39E93] hover:text-[#C8AE6E]" data-testid={`admin-watch-clients-${w.id}`}>—</button>;
  return (
    <button type="button" onClick={onToggle} className={`text-xs text-left hover:text-[#E6D5AC] ${open ? "text-[#E6D5AC]" : "text-[#C8AE6E]"}`} data-testid={`admin-watch-clients-${w.id}`}>
      {n > 0 && <span className="flex items-center gap-1"><Lock className="w-3 h-3" /> {n} cativo{n > 1 ? "s" : ""} · {w.holds.map((h) => h.name.split(" ")[0]).join(", ")}</span>}
      {i > 0 && <span className="block text-[#A39E93]">{i} interessado{i > 1 ? "s" : ""}</span>}
    </button>
  );
}

export function WatchClientsPanel({ w, reload }) {
  const [newOpen, setNewOpen] = useState(null);
  return (
    <div className="bg-[#0C0B09] p-4 space-y-3" data-testid={`admin-watch-clients-panel-${w.id}`}>
      <div className="flex flex-wrap items-center gap-3 text-xs text-[#A39E93]">
        <span>Stock {w.stock_qty} · cativas {w.holds.length} · disponíveis {w.available_qty}</span>
        <button type="button" className="btn-gold !py-1 !px-3 text-xs ml-auto disabled:opacity-40" disabled={w.available_qty <= 0} onClick={() => setNewOpen("reservation")} data-testid={`admin-watch-new-reservation-${w.id}`}><Lock className="w-3.5 h-3.5" /> Reservar para cliente</button>
        <button type="button" className="btn-line !py-1 !px-3 text-xs disabled:opacity-40" disabled={w.available_qty <= 0} onClick={() => setNewOpen("purchase")} data-testid={`admin-watch-new-sale-${w.id}`}><Plus className="w-3.5 h-3.5" /> Venda direta</button>
        <button type="button" className="btn-line !py-1 !px-3 text-xs" onClick={() => setNewOpen(w.available_qty > 0 ? "contact" : "waitlist")} data-testid={`admin-watch-new-interest-${w.id}`}><Plus className="w-3.5 h-3.5" /> Registar interesse</button>
      </div>
      {w.holds.map((h) => <HoldRow key={h.id} wid={w.id} h={h} onChange={reload} listPrice={w.promo_price_cents || w.price_cents} />)}
      {(w.interests || []).length > 0 && (
        <div className="flex flex-wrap gap-2 text-xs">
          {w.interests.map((p) => (
            <span key={p.id} className="border border-[#282520] px-2 py-1 flex items-center gap-2" data-testid={`admin-watch-interest-${p.id}`}>
              <Link to={`/admin/pedidos/${p.id}`} className="hover:text-[#E6D5AC]">{p.ref} · {REQ_TYPES[p.type]} · {p.name} · {REQ_STATUS[p.status]}</Link>
              {p.client_key && <Link to={`/admin/clientes/${p.client_key}`} className="text-[#C8AE6E] hover:underline">ficha</Link>}
            </span>
          ))}
        </div>
      )}
      {!w.holds.length && !(w.interests || []).length && <p className="text-xs text-[#A39E93]">Sem clientes associados a este relógio.</p>}
      {newOpen && <NewRequestModal initial={{ type: newOpen, watch_id: w.id }} onClose={() => setNewOpen(null)} onCreated={() => { setNewOpen(null); reload(); }} />}
    </div>
  );
}
